<template>
  <div class="info-page edit-list-page">
<!--    <Content class="cust-content">-->
<!--      <Row class="content-info">-->
        <Row id="printDom">
          <Col span="24">

            <SearchWrapper v-if="this.source === 'INVOICE'">
              <Form :label-width="90" inline
                    ref="searchFormValidate"
                    :rules="searchFormValidate"
                    :model="searchInfo"
                    class="entity-form">
                <Collapse v-model="searchInfoSwitch">
                  <Panel name="1">
                    <strong :style="{'padding-right': '5px'}">{{ $t('common.commonVar.searchInfo') }}</strong>
                    [
                    {{ $t('module.proj.projstatistic.searchInfo.searchType') }}:<strong :style="{'padding-right': '5px'}">{{ formatI18nValue('common.commonVar.transDtSearchTypeList.', this.searchedForm.searchType) }}</strong>
                    <Span v-if="this.searchedForm.searchType === 'MONTH'">
                      {{ $t('module.proj.projstatistic.searchInfo.searchMonth') }}:
                      <strong :style="{'padding-right': '5px'}">
                        （{{ formatI18nValue('common.commonVar.searchMonthTypeList.', this.searchedForm.searchMonthType) }}）
                        {{ this.formatDateToMonth(this.searchedForm.searchMonth) }}
                      </strong>
                    </Span>
                    <Span v-else-if="searchedForm.searchType === 'DT_SCOPE'">
                      {{ $t('module.proj.projstatistic.searchInfo.searchDtScope') }}:<strong :style="{'padding-right': '5px'}">{{ this.formatDateToDay(this.searchedForm.searchStartDt) + ' ~ ' + this.formatDateToDay(this.searchedForm.searchEndDt) }}</strong>
                    </Span>
                    {{ $t('module.proj.projsettleinvoice.searchInfo.searchEntityId') }}:<strong :style="{'padding-right': '5px'}">{{ (item = projSettleEntityList.find(entity => (entity.entityId === this.searchedForm.searchEntityId))) ? item.entityName : '' }}</strong>
                    {{ $t('module.proj.projsettleinvoice.searchInfo.searchInvCollectUnitId') }}:<strong :style="{'padding-right': '5px'}">{{ findItemDescrByValue(projCtrAcctDDList, this.searchedForm.searchInvCollectUnitId) }}</strong>
                    {{ $t('module.proj.projstatistic.searchInfo.searchDocIndex') }}:<strong :style="{'padding-right': '5px'}">{{ this.searchedForm.searchDocMonthIndex }}</strong>
                    {{ $t('module.proj.projsettleinvoice.searchInfo.searchInvNumber') }}:<strong :style="{'padding-right': '5px'}">{{ this.searchedForm.searchInvNumber }}</strong>
                    {{ $t('module.proj.projsettleinvoice.searchInfo.searchInvBillUnit') }}:<strong :style="{'padding-right': '5px'}">{{ this.searchedForm.searchInvBillUnit }}</strong>
                    {{ $t('module.proj.projsettleinvoice.searchInfo.searchInvAmt') }}:<strong :style="{'padding-right': '5px'}">{{ this.searchedForm.searchInvAmt || '' }}</strong>
                    {{ $t('module.proj.projsettleinvoice.searchInfo.searchCertStatus') }}:<strong :style="{'padding-right': '5px'}">{{ formatI18nValue('common.commonVar.invCertStatusList.', this.searchedForm.searchCertStatus) }}</strong>
                    ]
                    <Row class="content-row no-print" slot="content" :style="{'font-size':'12px'}">
                      <Col span="9">
                        <FormItem :label="$t('module.proj.projstatistic.searchInfo.searchType')" prop="searchType">
                          <RadioGroup v-model="searchType">
                            <Radio v-for="item in transDtSearchTypeList" v-if="isActiveItem(item)" :label="item.value" :key="item.value" :value="item.value">
                              {{ formatI18nValue('common.commonVar.transDtSearchTypeList.', item.value) }}
                            </Radio>
                          </RadioGroup>
                        </FormItem>
                      </Col>
                      <template v-if="searchType === 'MONTH'">
                        <Col span="8" offset="0">
                          <FormItem :label="$t('module.proj.projstatistic.searchInfo.searchMonth') + ' (' + $t('common.commonVar.settleDtNoticePrefix') + findItemDescrByValue(projSettleDtNumList, projectInfo.projSettleDtNum) + ')'" :labelWidth="220" prop="searchMonth">
                            <DatePicker v-model="searchMonth" type="month"
                                        :placeholder="$t('module.proj.projstatistic.searchInfo.searchMonthPH')" v-bind:transfer="true" :clearable="false"/>
                          </FormItem>
                        </Col>
                      </template>
                      <template v-else-if="searchType === 'DT_SCOPE'">
                        <Col span="6" offset="0">
                          <FormItem :label="$t('module.proj.projstatistic.searchInfo.searchStartDt')" prop="searchStartDt">
                            <DatePicker v-model="searchStartDt" transfer
                                        type="date"
                                        :placeholder="$t('module.proj.projstatistic.searchInfo.searchStartDtPH')"
                                        style="width: 100%;"
                                        @on-change="handleStartDtChange"
                            />
                          </FormItem>
                        </Col>
                        <Col span="6" offset="0">
                          <FormItem :label="$t('module.proj.projstatistic.searchInfo.searchEndDt')" prop="searchEndDt">
                            <DatePicker v-model="searchEndDt" transfer
                                        type="date"
                                        :placeholder="$t('module.proj.projstatistic.searchInfo.searchEndDtPH')"
                                        style="width: 100%;"
                                        ref="searchEndDt"
                                        :options="{ disabledDate: (date) => (this.searchStartDt >= date) }"
                            />
                          </FormItem>
                        </Col>
                      </template>
                    </Row>
                    <Row class="content-row no-print" slot="content" :style="{'font-size':'12px'}">
                      <Col span="5">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchEntityId')" prop="searchEntityId">
                          <Select v-model="searchEntityId" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchEntityIdPH')" v-bind:transfer="true" filterable clearable>
<!--                            <Option :label="$t('common.commonVar.naValue')" :value="this.$store.state.NA_VALUE" :style="{'text-align': 'left', 'color': 'red'}"></Option>-->
                            <OptionGroup v-for="groupItem in costColumnDDList" :key="groupItem.costColId" :value="groupItem.costColId" :label="groupItem.costColName">
                              <Option v-for="item in projSettleEntityList.filter(settleEntity => settleEntity.costColId === groupItem.costColId)" :key="item.entityId" :value="item.entityId" :style="{'text-align': 'left'}">{{ item.entityName }}</Option>
                            </OptionGroup>
                          </Select>
                        </FormItem>
                      </Col>
                      <Col span="5" offset="1">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchInvCollectUnitId')" prop="searchInvCollectUnitId">
                          <Select v-model="searchInvCollectUnitId" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchInvCollectUnitIdPH')" v-bind:transfer="true" clearable>
                            <Option v-for="item in projCtrAcctDDList" v-if="isActiveItem(item)" :key="item.value" :value="item.value" :label="item.descr" />
                          </Select>
                        </FormItem>
                      </Col>
                      <Col span="5" offset="1">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchDocIndex')" prop="searchDocMonthIndex">
                          <Select v-model="searchDocMonthIndex" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchDocIndexPH')" v-bind:transfer="true" filterable clearable @on-change="searchDocMonthIndexChanged">
                            <Option :label="$t('common.commonVar.naValue')" :value="this.$store.state.NA_VALUE" :style="{'text-align': 'left', 'color': 'red'}"></Option>
                            <Option v-for="item in docMonthIndexList" :key="item.docMonthIndex" :value="item.docMonthIndex" :style="{'text-align': 'left'}">{{ item.docMonthIndex }}</Option>
                            <!--                            <Option v-for="item in docMonthIndexList" :key="item.docMonthIndex" :value="item.docMonthIndex" :style="{'text-align': 'left'}">{{ ((item.docType === 'MONTH_INDEX') ? '&nbsp;&nbsp;' : '') + item.docMonthIndex }}{{ ' ' + '（' + ((item.docType === 'MONTH_INDEX') ? ($t('common.commonVar.sum') + item.num) : ($t('common.commonVar.max') + item.maxIndex)) + '）' }}</Option>-->
                            <!--                            {{ ' ' + '（' + ((item.docType === 'MONTH_INDEX') ? ($t('common.commonVar.sum') + item.num) : ($t('common.commonVar.max') + item.maxIndex)) + '）' }}-->
                          </Select>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row class="content-row no-print" slot="content" :style="{'font-size':'12px'}">
                      <Col span="5">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchInvNumber')" prop="searchInvNumber">
                          <Select v-model="searchInvNumber" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchInvNumberPH')" v-bind:transfer="true" filterable clearable>
                            <Option :label="$t('common.commonVar.naValue')" :value="this.$store.state.NA_VALUE" :style="{'text-align': 'left', 'color': 'red'}"></Option>
                            <Option v-for="item in invNumberList" :key="item.value" :value="item.value" :label="item.descr" />
                          </Select>
                        </FormItem>
                      </Col>
                      <Col span="5" offset="1">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchInvBillUnit')" prop="searchInvBillUnit">
                          <Select v-model="searchInvBillUnit" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchInvBillUnitPH')" v-bind:transfer="true" filterable clearable>
                            <Option :label="$t('common.commonVar.naValue')" :value="this.$store.state.NA_VALUE" :style="{'text-align': 'left', 'color': 'red'}"></Option>
                            <Option v-for="item in invBillUnitList" :key="item.value" :value="item.value" :label="item.descr" />
                          </Select>
                        </FormItem>
                      </Col>
                      <Col span="5" offset="1">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchInvAmt')" prop="searchInvAmt">
                          <InputNumber v-model="searchInvAmt" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchInvAmtPH')" clearable
                                      :max="1000000000" :min="-1000000000"
                                      :formatter="formatThousandthNumberComputed"
                                      :parser="parserThousandthNumberComputed" />
                        </FormItem>
                      </Col>
                    </Row>
                    <Row class="content-row no-print" slot="content" :style="{'font-size':'12px'}">
                      <Col span="5">
                        <FormItem :label="$t('module.proj.projsettleinvoice.searchInfo.searchCertStatus')" prop="searchCertStatus">
                          <Select v-model="searchCertStatus" :placeholder="$t('module.proj.projsettleinvoice.searchInfo.searchCertStatusPH')" v-bind:transfer="true" clearable>
                            <Option :label="$t('common.commonVar.naValue')" :value="this.$store.state.NA_VALUE" :style="{'text-align': 'left', 'color': 'red'}"></Option>
                            <Option v-for="item in invCertStatusList" :key="item.value" :value="item.value" :label="formatI18nValue('common.commonVar.invCertStatusList.', item.value)" />
                          </Select>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row slot="content" :style="{'font-size':'12px'}">
                      <Col span="4">
                        <Button type="primary" @click="goSearch">
                          {{$t("common.queryBar.searchBT")}}
                        </Button>
                      </Col>
                    </Row>
                  </Panel>
                </Collapse>
              </Form>
            </SearchWrapper>

            <Form id="invoiceSummaryTableForm" class="list-form" style="padding: 10px 0;" v-if="authedFnKeyMap.FK7S5U && source === 'INVOICE'">
<!--            :row-class-name="rowClassName"-->
<!--              <Table ref="invoiceSummaryTable" :columns="invoiceSummaryColumns" :data="invoiceSummary ? [invoiceSummary] : [{}]" border />-->
              <Table ref="invoiceSummaryTable" :columns="invoiceSummaryColumns" :data="[invoiceSummary || {}]" border :loading="isListLoading">
                <template slot-scope="{ row, index }" slot="selectMonth">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ formatDateToMonth(searchedForm.searchMonth) }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="inTaxReceivable">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ formatThousandthNumberAllowZero(row.inTaxReceivable) }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="inTaxReceived">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ formatThousandthNumberAllowZero(row.inTaxReceived) }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="vatSurchargeReceivable">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ formatThousandthNumberAllowZero(row.vatSurchargeReceivable) }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="vatSurchargeReceived">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ formatThousandthNumberAllowZero(row.vatSurchargeReceived) }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="totalTaxNotCollected">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ formatThousandthNumberAllowZero(row.totalTaxNotCollected) }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="projVat">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ (formatThousandthNumberAllowZero(row.projVat * 100) + ' %') }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="projInTax">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ (formatThousandthNumberAllowZero(row.projInTax * 100) + ' %') }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="otherTax">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ (formatThousandthNumberAllowZero(row.otherTax * 100) + ' %') }}</span>
                </template>
                <template slot-scope="{ row, index }" slot="totalTax">
                  <span v-if="searchedForm.searchType === 'MONTH'">{{ (formatThousandthNumberAllowZero(row.totalTax * 100) + ' %') }}</span>
                </template>
              </Table>
            </Form>

            <Form ref="listValidate" id="listTableForm"
                  :rules="listValidate"
                  :model="invoiceInfo"
                  class="list-form">
              <Table ref="transTable"
                     :max-height="fixedHeader ? tableHeight : ''" :row-class-name="rowClassName"
                     :columns="transColumns" :data="invoiceList" border show-summary :summary-method="handleSummary"
                     :loading="isListLoading">

                <template slot-scope="{ row, index }" slot="entityId">
                  <span :style="editIndex === index ? {'line-height':'32px'} : {}">
                    <template v-if="row.invId">
                      {{ (item = projSettleEntityList.find(entity => (entity.entityId === row.entityId))) ? item.entityName : '' }}
                    </template>
                    <template v-else-if="editIndex === index">
                      {{ (item = projSettleEntityList.find(entity => (entity.entityId === entityId))) ? item.entityName : '' }}
                    </template>
                  </span>
                </template>

                <template slot-scope="{ row, index }" slot="invCollectUnitId">
                  <Select v-model="invCollectUnitId" :placeholder="$t('module.proj.projsettleinvoice.info.invCollectUnitIdPH')" v-if="editIndex === index" v-bind:transfer="true" clearable>
                    <Option v-for="item in projCtrAcctDDList" v-if="isActiveItem(item)" :key="item.value" :value="item.value">
                      {{ item.descr }}
                    </Option>
                  </Select>
                  <span v-else>{{ findItemDescrByValue(projCtrAcctDDList, row.invCollectUnitId) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="docIndex">
                  <template v-if="row.invId">
                    <template v-if="editIndex === index">
                      <span :style="{'line-height':'32px'}">{{ '#' + formatIntMonth(row.docMth) + (row.docIndex ? '-' + row.docIndex : '') }}</span>
                    </template>
                    <template v-else>
                      <template v-if="source === 'INVOICE'">
                        <Tooltip :content="$t('common.commonVar.findSettleTransListByDocIndex')" placement="top" v-bind:transfer="true">
                          <a href="javascript:void(0)" @click="findSettleTransListByDocIndex(row, index)">{{ '#' + formatIntMonth(row.docMth) + (row.docIndex ? '-' + row.docIndex : '') }}</a>
                        </Tooltip>
                      </template>
                      <template v-else>
                        <span>{{ '#' + formatIntMonth(row.docMth) + (row.docIndex ? '-' + row.docIndex : '') }}</span>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <span v-if="editIndex === index" :style="{'line-height':'32px'}">{{ '#' + formatIntMonth(docMth) + (docIndex ? '-' + docIndex : '') }}</span>
                  </template>
                </template>

                <template slot-scope="{ row, index }" slot="invCode">
                  <Input v-model="invCode" :placeholder="$t('module.proj.projsettleinvoice.info.invCodePH')" v-if="editIndex === index" />
                  <span v-else>{{ row.invCode }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invNumber">
                  <Input v-model="invNumber" :placeholder="$t('module.proj.projsettleinvoice.info.invNumberPH')" v-if="editIndex === index" />
                  <span v-else>{{ row.invNumber }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invDt">
                  <FormItem prop="invDt" v-if="editIndex === index">
                    <DatePicker v-model="invDt" type="date" :placeholder="$t('module.proj.projsettleinvoice.info.invDtPH')" v-bind:transfer="true" />
                  </FormItem>
                  <span v-else>{{ formatDateToDay(row.invDt) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invBillUnit">
                  <Input v-model="invBillUnit" :placeholder="$t('module.proj.projsettleinvoice.info.invBillUnitPH')" v-if="editIndex === index" />
                  <span v-else>{{ row.invBillUnit }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invContent">
                  <Input v-model="invContent" :placeholder="$t('module.proj.projsettleinvoice.info.invContentPH')" v-if="editIndex === index" />
                  <span v-else>{{ row.invContent }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invValueAmt">
                  <InputNumber v-model="invValueAmt" :placeholder="$t('module.proj.projsettleinvoice.info.invValueAmtPH')" v-if="editIndex === index"
                               :max="1000000000" :min="-1000000000"
                               :formatter="formatThousandthNumberComputed"
                               :parser="parserThousandthNumberComputed" />
                  <span v-else>{{ formatThousandthNumber(row.invValueAmt) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invRate">
                  <template v-if="editIndex === index">
                    <template v-if="(['BY_MACHINE', 'QUOTA'].indexOf(invType) >= 0)"></template>
                    <template v-else>
                      <Tooltip v-if="invType === 'SPECIAL'" style="float:left; width: auto;" :content="$t('common.commonVar.autoCalculation')" placement="top" v-bind:transfer="true">
                        <a href="javascript:void(0)" @click="calculateInvDeductibleAmt"><Icon type="ios-calculator" style="line-height: 32px;"/></a>
                      </Tooltip>
                      <InputNumber style="width: 60%"
                                   v-model="invRate" :placeholder="$t('module.proj.projsettleinvoice.info.invRatePH')"
                                   :max="100" :min="0" :precision="0"/> %
                    </template>
<!--                    :formatter="value => `${value}%`"-->
<!--                    :parser="value => value.replace('%', '')"-->
                  </template>
                  <span v-else>{{ row.invRate ? (row.invRate + '%') : '' }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="indManualDeductibleValue">
                  <template v-if="editIndex === index">
                    <Select v-model="indManualDeductibleValue" :placeholder="$t('module.proj.projsettleinvoice.info.indManualDeductibleValuePH')" transfer>
                      <Option v-for="item in indList" v-if="isActiveItem(item)" :key="item.value" :value="item.value">
                        {{ formatI18nValue('common.commonVar.indList.', item.value) }}
                      </Option>
                    </Select>
                  </template>
                  <span v-else>{{ formatI18nValue('common.commonVar.indList.', row.indManualDeductibleValue) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invDeductibleAmt">
                  <template v-if="editIndex === index">
                    <InputNumber v-if="indManualDeductibleValue === 'Y'" v-model="invDeductibleAmt" :placeholder="$t('module.proj.projsettleinvoice.info.invDeductibleAmtPH')"
                                :max="1000000000" :min="-1000000000"
                                :formatter="formatThousandthNumberComputed"
                                :parser="parserThousandthNumberComputed" />
                    <span v-else :style="{'line-height':'32px'}">{{ formatThousandthNumber(invDeductibleAmt) }}</span>
                  </template>
                  <span v-else>{{ formatThousandthNumber(row.invDeductibleAmt) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invSubtotalAmt">
                  <span v-if="editIndex === index" :style="{'line-height':'32px'}">
                    {{ formatThousandthNumber(invValueAmt + invDeductibleAmt) }}
                  </span>
                  <span v-else>{{ formatThousandthNumber(row.invSubtotalAmt) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invType">
                  <Select v-model="invType" :placeholder="$t('module.proj.projsettleinvoice.info.invTypePH')" v-if="editIndex === index" v-bind:transfer="true" clearable>
                    <Option v-for="item in invTypeList" v-if="isActiveItem(item)" :key="item.value" :value="item.value">
                      {{ formatI18nValue('common.commonVar.invTypeList.', item.value) }}
                    </Option>
                  </Select>
                  <span v-else>{{ formatI18nValue('common.commonVar.invTypeList.', row.invType) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="invPaymentType">
                  <Select v-model="invPaymentType" :placeholder="$t('module.proj.projsettleinvoice.info.invPaymentTypePH')" v-if="editIndex === index" v-bind:transfer="true" clearable>
                    <Option v-for="item in invPaymentTypeList" v-if="isActiveItem(item)" :key="item.value" :value="item.value">
                      {{ formatI18nValue('common.commonVar.invPaymentTypeList.', item.value) }}
                    </Option>
                  </Select>
                  <span v-else>{{ formatI18nValue('common.commonVar.invPaymentTypeList.', row.invPaymentType) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="submitDt">
                  <template v-if="row.invId">
                    <a v-if="authedFnKeyMap.FMQYZ5 && editIndex === -1" href="javascript:void(0)" @click="showModalCertInfo(row, index)">
                      <Icon class="edit-cls list-icon-cls" type="ios-create"/>
                      <span class="edit-cls">{{ formatDateToDay(row.submitDt) }}</span>
                    </a>
                    <template v-else-if="editIndex === index">
                      <span :style="{'line-height':'32px'}">{{ formatDateToDay(row.submitDt) }}</span>
                    </template>
                    <template v-else>
                      {{ formatDateToDay(row.submitDt) }}
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="authedFnKeyMap.FMQYZ5 && editIndex === index">
                      <FormItem prop="submitDt" v-if="editIndex === index">
                        <DatePicker v-model="submitDt" type="date" :placeholder="$t('module.proj.projsettleinvoice.info.submitDtPH')" v-bind:transfer="true" />
                      </FormItem>
                    </template>
                  </template>
                </template>

                <template slot-scope="{ row, index }" slot="certAmt">
                  <template v-if="row.invId">
                    <a v-if="authedFnKeyMap.FMQYZ5 && editIndex === -1" href="javascript:void(0)" @click="showModalCertInfo(row, index)">
                      <Icon class="edit-cls list-icon-cls" type="ios-create"/>
                      <span class="edit-cls">{{ formatThousandthNumber(row.certAmt) }}</span>
                    </a>
                    <template v-else-if="editIndex === index">
                      <span :style="{'line-height':'32px'}">{{ formatThousandthNumber(row.certAmt) }}</span>
                    </template>
                    <template v-else>
                      {{ formatThousandthNumber(row.certAmt) }}
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="authedFnKeyMap.FMQYZ5 && editIndex === index">
                      <InputNumber v-model="certAmt" :placeholder="$t('module.proj.projsettleinvoice.info.certAmtPH')"
                                   :max="1000000000" :min="-1000000000"
                                   :formatter="formatThousandthNumberComputed"
                                   :parser="parserThousandthNumberComputed" />
                    </template>
                    <template v-else>
                      {{ formatThousandthNumber(row.certAmt) }}
                    </template>
                  </template>
                </template>

                <template slot-scope="{ row, index }" slot="diffCertAmt">
                  <span v-if="editIndex === index" :style="{'line-height':'32px'}">
<!--                    {{ formatThousandthNumber(invDeductibleAmt - certAmt) }}-->
                  </span>
                  <span v-else>{{ formatThousandthNumber(row.diffCertAmt) }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="remarks">
                  <Input type="textarea" :rows="2" :autosize="{ minRows: 2, maxRows: 2 }" v-model="remarks" :placeholder="$t('module.proj.projsettleinvoice.info.remarksPH')" v-if="editIndex === index" />
                  <span v-else>{{ row.remarks }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="action" v-if="authedFnKeyMap.FMQYZ5 && ['BEFORE_SUMMARY', 'MONTH_SUBTOTAL', 'MONTH_TOTAL'].indexOf(row.colType) == -1">
                  <div v-if="!enableEdit"></div>
                  <div v-else-if="row.isBottomRow">
                    <template v-if="source === 'TRANS'">
                      <div v-if="editIndex === index" :style="{'line-height':'32px'}">
                        <Button @click="handleInsertTrans(row, index)" type="primary">{{$t("common.commonVar.actionSave")}}</Button>
                        <Button @click="editIndex = -1" :style="{marginLeft:'5px'}">{{$t("common.commonVar.actionCancel")}}</Button>
                      </div>
                      <div v-else>
                        <Button @click="handleAddTrans(row, index)" type="primary">{{$t("common.commonVar.actionAdd")}}</Button>
                      </div>
                    </template>
                  </div>
                  <div v-else>
                    <div v-if="row.checkedStatus === 'P'"><Tag color="success">{{ $t("common.commonVar.checked") }}</Tag></div>
                    <div v-else-if="editIndex === index" :style="{'line-height':'32px'}">
                      <Button @click="handleUpdateTrans(row, index)" type="primary">{{$t("common.commonVar.actionSave")}}</Button>
                      <Button @click="editIndex = -1" :style="{marginLeft:'5px'}">{{$t("common.commonVar.actionCancel")}}</Button>
                    </div>
                    <div v-else>
                      <Button v-if="source === 'TRANS'" @click="handleCopyTrans(row, index)" :style="{marginRight:'5px'}" type="success">{{$t("common.commonVar.actionCopy")}}</Button>
                      <Button @click="handleEditTrans(row, index)" :style="{marginRight:'5px'}">{{$t("common.commonVar.actionEdit")}}</Button>
                      <Button @click="handleRemoveTrans(row, index)" type="error">{{$t("common.commonVar.actionDelete")}}</Button>
                    </div>
                  </div>
                </template>
              </Table>

              <!--    @on-cancel=""-->
              <Modal v-model="modalCertInfo" :title="$t('common.commonVar.docIndexTitle')" @on-ok="saveCertInfo" >
                <Row>
                  <Col span="6" offset="0">
                    <FormItem :label="$t('module.proj.projsettleinvoice.info.submitDt')" prop="submitDt">
                      <DatePicker v-model="submitDt" type="date" :placeholder="$t('module.proj.projsettleinvoice.info.submitDtPH')" v-bind:transfer="true" />
                    </FormItem>
                  </Col>
                  <Col span="6" offset="1">
                    <FormItem class="edit-list-page" :label="$t('module.proj.projsettleinvoice.info.certAmt')" prop="certAmt">
                      <InputNumber class="list-form" v-model="certAmt" :placeholder="$t('module.proj.projsettleinvoice.info.certAmtPH')"
                                   :max="1000000000" :min="-1000000000"
                                   :formatter="formatThousandthNumberComputed"
                                   :parser="parserThousandthNumberComputed" />
                    </FormItem>
                  </Col>
                  <Col span="6" offset="1">
                    <FormItem :label="$t('module.proj.projsettleinvoice.info.remarks')" prop="remarks">
                      <Input type="textarea" :rows="2" :autosize="{ minRows: 2, maxRows: 2 }" v-model="remarks" :placeholder="$t('module.proj.projsettleinvoice.info.remarksPH')" />
                    </FormItem>
                  </Col>
                </Row>
              </Modal>
            </Form>
          </Col>
        </Row>
<!--      </Row>-->
      <Row class="content-info">
        <Row style="text-align: center;">
        </Row>
      </Row>
<!--    </Content>-->
  </div>
</template>

<script>
import * as dayjs from 'dayjs'
import * as Utils from '@/utils'
import SearchWrapper from '@/components/wrapper/SearchWrapper'

export default {
  components: {
    // Title
    SearchWrapper
  },
  props: {
    compId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    projId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    entityId: {
      type: String,
      require: false,
      default: () => {
        return ''
      }
    },
    transId: {
      type: String,
      require: false,
      default: () => {
        return ''
      }
    },
    docMth: {
      type: Number,
      require: false,
      default: () => {
        return 0
      }
    },
    docIndex: {
      type: Number,
      require: false,
      default: () => {
        return 0
      }
    },
    source: {
      type: String,
      require: true,
      default: () => {
        return 'TRANS' // TRANS-成本栏结算人的凭证明细页面， INVOICE-成本票台账页面
      }
    },
    enableEdit: {
      type: Boolean,
      require: false,
      default: () => {
        return true
      }
    }
  },
  data() {
    return {
      fixedHeader: true,
      tableHeight: 400,
      isListLoading: false,
      isShowPairSpin: false,
      isDeleteLoading: false,
      parentPath: '',
      parentTitle: '',
      modalCertInfo: false,
      searchInfoSwitch: '0',
      searchFormValidate: {
        searchType: [
          { required: true, message: this.$t('module.proj.projstatistic.searchValidateInfo.searchTypeRequired'), trigger: 'change' }
        ]
      },
      // baseInfoSwitch: '0',
      // indEditEntity: false,
      entityFormValidate: {
        // entityName: [
        //   { required: true, message: this.$t('module.proj.project.projsettleentity.validateInfo.entityNameRequired'), trigger: 'change' }
        // ],
        // ctrAcctId: [
        //   { required: true, message: this.$t('module.proj.project.projsettleentity.validateInfo.ctrAcctIdRequired'), trigger: 'change' }
        // ],
        // costColId: [
        //   { required: true, message: this.$t('module.proj.project.projsettleentity.validateInfo.costColIdRequired'), trigger: 'change' }
        // ]
      },
      // settleEditIndex: -1,
      // settleEntityName: '',
      listValidate: {
        // transDt: [
        //   { required: true, message: this.$t('module.proj.projsettleinvoice.validateInfo.transDtRequired'), trigger: 'change', pattern: /.+/ }
        // ]
      },
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px'
      },
      invoiceSummaryColumns: [
        {
          title: this.$t('common.commonVar.selectMonth'),
          slot: 'selectMonth',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.inTaxReceivable'),
          slot: 'inTaxReceivable',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.inTaxReceived'),
          slot: 'inTaxReceived',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.vatSurchargeReceivable'),
          slot: 'vatSurchargeReceivable',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.vatSurchargeReceived'),
          slot: 'vatSurchargeReceived',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.totalTaxNotCollected'),
          slot: 'totalTaxNotCollected',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.projVat'),
          slot: 'projVat',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.projInTax'),
          slot: 'projInTax',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.otherTax'),
          slot: 'otherTax',
          align: 'right'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.summary.totalTax'),
          slot: 'totalTax',
          align: 'right'
        }
      ],
      transColumns: [
        // {
        //   title: this.$t('module.proj.projsettleinvoice.info.transDt'),
        //   slot: 'transDt',
        //   align: 'center',
        //   width: 110,
        //   fixed: 'left'
        // },
        {
          title: this.$t('module.proj.projsettleinvoice.info.entityId'),
          slot: 'entityId',
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invCollectUnitId'),
          slot: 'invCollectUnitId',
          align: 'center',
          width: 80,
          fixed: 'left'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.docIndex'),
          slot: 'docIndex',
          align: 'left',
          width: 90,
          fixed: 'left'
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invCode'),
          slot: 'invCode',
          align: 'left',
          width: 110
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invNumber'),
          slot: 'invNumber',
          align: 'left',
          width: 100
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invDt'),
          slot: 'invDt',
          align: 'center',
          width: 110
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invBillUnit'),
          slot: 'invBillUnit',
          align: 'left',
          width: 100
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invContent'),
          slot: 'invContent',
          align: 'left',
          width: 100
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invValueAmt'),
          slot: 'invValueAmt',
          key: 'invValueAmt',
          align: 'right',
          width: 90
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invRate'),
          slot: 'invRate',
          align: 'center',
          width: 80
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invDeductibleValue'),
          align: 'center',
          children: [
            {
              title: this.$t('module.proj.projsettleinvoice.info.indManualDeductibleValue'),
              slot: 'indManualDeductibleValue',
              align: 'center',
              width: 80
            },
            {
              title: this.$t('module.proj.projsettleinvoice.info.invDeductibleAmt'),
              slot: 'invDeductibleAmt',
              key: 'invDeductibleAmt',
              align: 'right',
              width: 80
            }
          ]
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invSubtotalAmt'),
          slot: 'invSubtotalAmt',
          key: 'invSubtotalAmt',
          align: 'right',
          width: 90
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invType'),
          slot: 'invType',
          align: 'center',
          width: 85
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.invPaymentType'),
          slot: 'invPaymentType',
          align: 'center',
          width: 85
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.submitDt'),
          slot: 'submitDt',
          align: 'center',
          width: 110
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.certAmt'),
          slot: 'certAmt',
          key: 'certAmt',
          align: 'right',
          width: 90
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.diffCertAmt'),
          slot: 'diffCertAmt',
          key: 'diffCertAmt',
          align: 'right',
          width: 90
        },
        {
          title: this.$t('module.proj.projsettleinvoice.info.remarks'),
          slot: 'remarks',
          align: 'center',
          width: 100
        },
        {
          title: this.$t('common.commonVar.action'),
          className: 'no-print',
          align: 'center',
          width: (this.source === 'TRANS' ? 120 : 90),
          fixed: 'right',
          slot: 'action'
        }
      ],
      selectedRecord: {},
      selectedIndex: -1,
      END_DATA: null
    }
  },
  computed: {
    resourceList() {
      return this.$store.state.permission.resourceList
    },
    authedFnKeyMap() {
      return this.$store.state.systemAuthManage.authedFnKeyMap
    },
    searchedForm() {
      return this.$store.state.projSettleInvoiceManage.searchedForm
    },
    searchInfo() {
      return this.$store.state.projSettleInvoiceManage.searchInfo
    },
    searchType: {
      get() {
        return this.searchInfo.searchType
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchType', value)
      }
    },
    searchMonth: {
      get() {
        return this.searchInfo.searchMonth
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchMonth', value)
      }
    },
    searchMonthType: {
      get() {
        return this.searchInfo.searchMonthType
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchMonthType', value)
      }
    },
    // searchDtScope: {
    //   get() {
    //     return this.searchInfo.searchDtScope
    //   },
    //   set(value) {
    //     this.$store.commit('projSettleInvoiceManage/updateSearchDtScope', value)
    //   }
    // },
    searchStartDt: {
      get() {
        return this.searchInfo.searchStartDt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchStartDt', value)
      }
    },
    searchEndDt: {
      get() {
        return this.searchInfo.searchEndDt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchEndDt', value)
      }
    },
    searchTransId: {
      get() {
        return this.searchInfo.searchTransId
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchTransId', value)
      }
    },
    searchEntityId: {
      get() {
        return this.searchInfo.searchEntityId
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchEntityId', value)
      }
    },
    searchInvCollectUnitId: {
      get() {
        return this.searchInfo.searchInvCollectUnitId
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchInvCollectUnitId', value)
      }
    },
    searchInvNumber: {
      get() {
        return this.searchInfo.searchInvNumber
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchInvNumber', value)
      }
    },
    searchInvBillUnit: {
      get() {
        return this.searchInfo.searchInvBillUnit
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchInvBillUnit', value)
      }
    },
    searchInvAmt: {
      get() {
        // return this.searchInfo.searchInvAmt
        return Utils.covertZeroToNull(this.searchInfo.searchInvAmt)
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchInvAmt', value)
      }
    },
    searchCertStatus: {
      get() {
        return this.searchInfo.searchCertStatus
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchCertStatus', value)
      }
    },
    searchDocMth: {
      get() {
        return this.searchInfo.searchDocMth
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchDocMth', value)
      }
    },
    searchDocIndex: {
      get() {
        return this.searchInfo.searchDocIndex
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchDocIndex', value)
      }
    },
    searchDocMonthIndex: {
      get() {
        return this.searchInfo.searchDocMonthIndex
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchDocMonthIndex', value)
      }
    },
    searchDocType: {
      get() {
        return this.searchInfo.searchDocType
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSearchDocType', value)
      }
    },
    projectInfo() {
      return this.$store.state.rspProjectManage.projectInfo
    },
    // trans
    editIndex: {
      get() {
        return this.$store.state.projSettleInvoiceManage.editIndex
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateEditIndex', value)
      }
    },
    justUpdatedIndex: {
      get() {
        return this.$store.state.projSettleInvoiceManage.justUpdatedIndex
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateJustUpdatedIndex', value)
      }
    },
    editAction: {
      get() {
        return this.$store.state.projSettleInvoiceManage.editAction
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateEditAction', value)
      }
    },
    invoiceSummary() {
      return this.$store.state.projSettleInvoiceManage.invoiceSummary
    },
    invoiceList() {
      return this.$store.state.projSettleInvoiceManage.invoiceList
    },
    invoiceInfo() {
      return this.$store.state.projSettleInvoiceManage.invoiceInfo
    },
    invId: {
      get() {
        return this.invoiceInfo.invId
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvId', value)
      }
    },
    colType: {
      get() {
        return this.invoiceInfo.colType
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateColType', value)
      }
    },
    invCollectUnitId: {
      get() {
        return this.invoiceInfo.invCollectUnitId
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvCollectUnitId', value)
      }
    },
    invCode: {
      get() {
        return this.invoiceInfo.invCode
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvCode', value)
      }
    },
    invNumber: {
      get() {
        return this.invoiceInfo.invNumber
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvNumber', value)
      }
    },
    invDt: {
      get() {
        return this.invoiceInfo.invDt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvDt', value)
      }
    },
    invBillUnit: {
      get() {
        return this.invoiceInfo.invBillUnit
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvBillUnit', value)
      }
    },
    invContent: {
      get() {
        return this.invoiceInfo.invContent
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvContent', value)
      }
    },
    invValueAmt: {
      get() {
        return this.invoiceInfo.invValueAmt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvValueAmt', value)
      }
    },
    indManualDeductibleValue: {
      get() {
        return this.invoiceInfo.indManualDeductibleValue
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateIndManualDeductibleValue', value)
      }
    },
    invDeductibleAmt: {
      get() {
        return this.invoiceInfo.invDeductibleAmt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvDeductibleAmt', value)
      }
    },
    invType: {
      get() {
        return this.invoiceInfo.invType
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvType', value)
      }
    },
    invRate: {
      get() {
        // debugger
        return this.invoiceInfo.invRate
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvRate', value)
      }
    },
    invPaymentType: {
      get() {
        return this.invoiceInfo.invPaymentType
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateInvPaymentType', value)
      }
    },
    submitDt: {
      get() {
        return this.invoiceInfo.submitDt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateSubmitDt', value)
      }
    },
    certAmt: {
      get() {
        return this.invoiceInfo.certAmt
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateCertAmt', value)
      }
    },
    remarks: {
      get() {
        return this.invoiceInfo.remarks
      },
      set(value) {
        this.$store.commit('projSettleInvoiceManage/updateRemarks', value)
      }
    },
    transDtSearchTypeList() {
      return this.$store.state.transDtSearchTypeList
    },
    projCtrAcctDDList() {
      return this.$store.state.confProjCtrAcctManage.projCtrAcctDDList
    },
    costColumnDDList() {
      return this.$store.state.rspCostColumnManage.costColumnDDList
    },
    projSettleEntityList() {
      return this.$store.state.confProjSettleEntityManage.projSettleEntityList
    },
    projSettlePaymentDDList() {
      return this.$store.state.confProjSettlePaymentManage.projSettlePaymentDDList
    },
    projSettleDtNumList() {
      return this.$store.state.projSettleDtNumList
    },
    docMonthIndexList() {
      return this.$store.state.transIndexManage.docMonthIndexList
    },
    docMonthIndexMap() {
      return this.$store.state.transIndexManage.docMonthIndexMap
    },
    invTypeList() {
      return this.$store.state.invTypeList
    },
    invPaymentTypeList() {
      return this.$store.state.invPaymentTypeList
    },
    invCertStatusList() {
      return this.$store.state.invCertStatusList
    },
    invNumberList() {
      return this.$store.state.projSettleInvoiceManage.invNumberList
    },
    invBillUnitList() {
      return this.$store.state.projSettleInvoiceManage.invBillUnitList
    },
    indList() {
      return this.$store.state.indList
    },
    formatThousandthNumberComputed: Utils.formatThousandthNumberComputed,
    parserThousandthNumberComputed: Utils.parserThousandthNumberComputed,
    END_COMPUTED() {
      return null
    }
  },
  methods: {
    handleStartDtChange() {
      if (this.searchStartDt !== '') {
        this.$refs['searchEndDt'].handleFocus()

        if (this.searchEndDt < this.searchStartDt) {
          this.searchEndDt = ''
        }
      } else {
        this.searchEndDt = ''
      }
    },
    formatI18nValue(prefix, value) {
      return value ? this.$t(prefix + value) : null
    },
    initFormValue() {
      let curDttm = new Date()
      if (!this.searchType) this.searchType = 'ALL'
      if (!this.searchMonth) this.searchMonth = this.getMonthFirstDay(curDttm)
      // if (!this.searchDtScope) this.searchDtScope = [this.getMonthFirstDay(curDttm), this.getMonthFirstDay(curDttm)]
      if (!this.searchStartDt) this.searchStartDt = this.getMonthFirstDay(curDttm)
      if (!this.searchEndDt) this.searchEndDt = this.getMonthFirstDay(curDttm)
      // debugger
      if (this.source === 'TRANS') {
        this.searchType = 'ALL'
        this.searchTransId = this.transId
        this.searchEntityId = this.entityId
      } else if (this.source === 'INVOICE') {
        if (this.$route.query.rptMth) {
          this.searchType = 'MONTH'
          this.searchMonth = dayjs(this.$route.query.rptMth + '-01').toDate()
        } else if (this.docMth) {
          this.searchType = 'ALL'
          this.searchDocType = 'MONTH_INDEX'
          this.searchDocMth = this.docMth
          this.searchDocIndex = this.docIndex
          this.searchDocMonthIndex = this.formatIntMonth(this.docMth) + (this.docIndex ? '-' + this.docIndex : '')
        }
      }
    },
    cleanForm() {
      this.$store.commit('projSettleInvoiceManage/updateProjSettleInvoiceListEmpty')
    },
    goBack() {
      // this.$router.back()
      this.$router.push({path: '/proj/project/entryStatistic', query: {projId: this.$route.query.projId, compId: this.$route.query.compId, menuKey: 'RspProjectHomePage'}})
    },
    getKeyParam() {
      return { projId: this.projId, compId: this.compId }
    },
    isActiveItem: Utils.isActiveItem,
    // isUsedItem: Utils.isUsedItem,
    formatDate: Utils.formatDate,
    formatDateToDay: Utils.formatDateToDay,
    formatDateToMonth: Utils.formatDateToMonth,
    formatDateToMonthInt: Utils.formatDateToMonthInt,
    formatIntMonth: Utils.formatIntMonth,
    findItemDescrByValue: Utils.findItemDescrByValue,
    // parseDate: Utils.parseDate,
    getMonthFirstDay: Utils.getMonthFirstDay,
    getMonthLastDay: Utils.getMonthLastDay,
    formatThousandthNumber: Utils.formatThousandthNumber,
    parserThousandthNumber: Utils.parserThousandthNumber,
    formatThousandthNumberAllowZero: Utils.formatThousandthNumberAllowZero,
    rowClassName(row, index) {
      let clz = ''
      if (this.editIndex === index) {
        clz += ' table-column-row'
      } else if (row.colType === 'BEFORE_SUMMARY') {
        clz += ' table-column-row'
      }
      // ...
      if (this.justUpdatedIndex === index) {
        clz += ' just-updated-row'
      }

      return clz
    },
    async handleCopyTrans(row, index) {
      // debugger
      if (this.source !== 'TRANS') return
      this.$store.commit('projSettleInvoiceManage/handleCopy', {row, index: (this.invoiceList.length - 1)})
    },
    async handleAddTrans(row, index) {
      // debugger
      if (this.source !== 'TRANS') return
      this.$store.commit('projSettleInvoiceManage/handleAdd', {row, index})
    },
    async handleInsertTrans(row, index) {
      this.$refs['listValidate'].validate((valid) => {
        if (valid) {
          this.doInsertTrans(index)
        } else {
          this.$Message.error({
            content: this.$t('common.commonVar.requiredFieldContent')
          })
        }
      })
    },
    async doInsertTrans(index) {
      // debugger
      const result = await this.$store.dispatch('projSettleInvoiceManage/insertProjSettleInvoice', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route), transId: this.transId, entityId: this.entityId})
      if (result.success) {
        this.$Message.success({
          content: this.$t('common.commonVar.insertSuccess')
        })
        this.$store.commit('projSettleInvoiceManage/appendBottomRow')
        await this.refreshListItem(index, result.data.invId)
        this.$Message.success({
          content: this.$t('common.commonVar.addToListButtom')
        })
      } else {
        if (result.code === 4024) {
          this.modalDocIndex = true
        }
      }
    },
    async handleEditTrans(row, index) {
      this.$store.commit('projSettleInvoiceManage/handleEdit', {row, index})
    },
    async handleUpdateTrans(row, index) {
      this.$refs['listValidate'].validate((valid) => {
        if (valid) {
          this.doUpdateTrans(row, index)
        } else {
          this.$Message.error({
            content: this.$t('common.commonVar.requiredFieldContent')
          })
        }
      })
    },
    async doUpdateTrans(row, index) {
      const result = await this.$store.dispatch('projSettleInvoiceManage/updateProjSettleInvoice', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route), invId: row.invId, transId: row.transId, entityId: row.entityId})
      if (result.success) {
        this.$Message.success({
          content: this.$t('common.commonVar.updateSuccess')
        })
        await this.refreshListItem(index)
      }
    },
    async handleRemoveTrans(row, index) {
      this.$Modal.confirm({
        title: this.$t('common.commonVar.notice'),
        content: this.$t('common.commonVar.noticeContent'),
        onOk: () => this.doRemoveTrans(row, index)
      })
    },
    async doRemoveTrans(row, index) {
      const result = await this.$store.dispatch('projSettleInvoiceManage/removeProjSettleInvoice', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route), invId: row.invId, transId: row.transId, entityId: row.entityId})
      if (result.success) {
        this.$Message.success({
          content: this.$t('common.commonVar.delSuccess')
        })
        await this.refreshListItem(index)
      }
    },
    async refreshList() {
      //
      this.isListLoading = true
      // debugger
      this.$store.commit('projSettleInvoiceManage/updateProjSettleInvoiceListEmpty')
      this.justUpdatedIndex = -1
      const result = await this.$store.dispatch('projSettleInvoiceManage/findProjSettleInvoiceList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      if (result.success) {
        let list = result.data
        if (this.source === 'TRANS') { // 如果是成本栏结算人的凭证明细页面
          list = list.filter(item => { // 过滤掉月合计、月累计
            return item.colType !== 'MONTH_TOTAL' && item.colType !== 'MONTH_SUBTOTAL'
          })
        }
        this.$store.commit('projSettleInvoiceManage/updateProjSettleInvoiceList', list)
        this.$store.dispatch('projSettleInvoiceManage/findRspProjSettleInvoiceSum', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      }
      this.$store.commit('projSettleInvoiceManage/appendBottomRow')
      this.isListLoading = false
    },
    async refreshListItem(index, invId) {
      const result = await this.$store.dispatch('projSettleInvoiceManage/findProjSettleInvoiceList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route), invId: invId || this.invoiceList[index].invId})
      if (result.success) {
        if (result.data && result.data.length) {
          this.$store.commit('projSettleInvoiceManage/updateProjSettleInvoiceListItem', {row: {...result.data[0], isBottomRow: false}, index})
          this.justUpdatedIndex = index
        } else { // 没有找到指定的唯一记录，说明需要从列表中删除该记录
          this.$store.commit('projSettleInvoiceManage/updateProjSettleInvoiceListItem', {row: null, index})
          this.justUpdatedIndex = -1
          this.$Message.success({
            content: this.$t('common.commonVar.removeFromList')
          })
        }
        this.editIndex = -1
        this.reloadDropdown()
        this.$store.dispatch('projSettleInvoiceManage/findRspProjSettleInvoiceSum', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      }
    },
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (!key) {
          sums[key] = {
            key,
            value: ''
          }
          return
        }
        if (index === 1) {
          sums[key] = {
            key,
            value: this.$t('common.commonVar.total')
          }
          return
        }
        let values = []
        values = data.filter(item => (item.colType !== 'MONTH_SUBTOTAL' && item.colType !== 'MONTH_TOTAL')).map(item => Number(item[key]))
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[key] = {
            key,
            value: this.formatThousandthNumber(v)
          }
        } else {
          sums[key] = {
            key,
            value: 'N/A'
          }
        }
      })

      return sums
    },
    async goSearch() {
      console.log(this.searchInfo)

      this.isShowPairSpin = true
      this.doSearchProcess()
      this.isShowPairSpin = false
    },
    async doSearchProcess() {
      await this.$store.commit('projSettleInvoiceManage/updateSearchedForm')
      await this.refreshList()
    },
    showModalCertInfo(row, index) {
      if (row.colType === 'BEFORE_SUMMARY') return
      if (index === this.editIndex) return
      // debugger
      if (row.invId && this.editIndex !== -1) {
        this.$Message.error({
          content: this.$t('common.commonVar.cancelCurModifyRowAlert')
        })
        return
      }
      this.selectedRecord = row
      this.selectedIndex = index
      this.justUpdatedIndex = -1
      console.info('this.selectedRecord:', this.selectedRecord)
      this.$store.commit('projSettleInvoiceManage/updateProjSettleInvoiceInfo', row)
      this.modalCertInfo = true
    },
    async saveCertInfo() {
      console.info('saveCertInfo begin', this.invoiceInfo)
      // 存在transId，是修改行记录的操作
      if (this.selectedRecord.invId) {
        const data = {
          submitDt: this.submitDt,
          certAmt: this.certAmt,
          remarks: this.remarks,
          invId: this.selectedRecord.invId,
          // transId: this.selectedRecord.transId,
          ...this.getKeyParam(),
          ...Utils.getCodeParam(this.$route)
        }
        const result = await this.$store.dispatch('projSettleInvoiceManage/updateProjSettleInvoiceCertInfo', data)
        if (result.success) {
          this.$Message.success({
            content: this.$t('common.commonVar.updateSuccess')
          })
          await this.refreshListItem(this.selectedIndex)
          this.modalCertInfo = false
        }
      } else {
        this.docMth = this.editDocMth
        this.docIndex = this.editDocIndex
        this.allowDuplicate = this.editAllowDuplicate
      }
    },
    searchDocMonthIndexChanged(value) {
      console.log('value:', value)
      let item = this.docMonthIndexMap[value]
      if (item) {
        this.searchDocMth = item.docMth
        this.searchDocIndex = item.docIndex
        this.searchDocType = item.docType
      } else {
        this.searchDocMth = 0
        this.searchDocIndex = 0
        this.searchDocType = ''
      }
    },
    async findSettleTransListByDocIndex(row, index) {
      console.info('index, row:', index, row)
      this.$store.commit('projSettleTransManage/resetSearchInfo')
      this.$router.push({path: '/proj/project/entrySettleTransList', query: {docMth: row.docMth, docIndex: row.docIndex, transId: row.transId, entityId: row.entityId, projId: row.projId, compId: row.compId, menuKey: 'RspProjectHomePage'}})
    },
    calculateInvDeductibleAmt() {
      if (this.invValueAmt && this.invType === 'SPECIAL') {
        if (this.indManualDeductibleValue !== 'Y') {
          this.invDeductibleAmt = this.invRate / 100 * this.invValueAmt
        }
      } else if (['BY_MACHINE', 'QUOTA'].indexOf(this.invType) >= 0) {
        this.invRate = 0
        this.invDeductibleAmt = 0
      } else {
        this.invDeductibleAmt = 0
      }
    },
    async reloadDropdown() {
      await this.$store.dispatch('projSettleInvoiceManage/findInvNumberList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      await this.$store.dispatch('projSettleInvoiceManage/findInvBillUnitList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    },
    printPage() {
      // #调试用, 将printFrame显示出来, 便于查看需要打印的内容
      // document.getElementById('printFrame').style.display = 'block'
      // document.getElementById('printFrame').style.height = '50%'
      // document.getElementById('printFrame').style.width = '100%'
      // document.getElementById('printFrame').style.top = '0'
      // document.getElementById('printFrame').style['z-index'] = '10000'
      // document.getElementById('printFrame').style['background-color'] = '#fff'
      let printWindow = document.getElementById('printFrame').contentWindow
      printWindow.document.body.innerHTML = '' // 清楚printFrame的内容
      let node = document.getElementById('printDom').cloneNode(true) // 将需要打印的内容拷贝到printFrame中
      printWindow.document.body.appendChild(node)

      // 处理浮动table，将table的data和summary部分都放到head所在的table中去
      let transTableList = printWindow.document.getElementById('transTableForm').getElementsByTagName('table')
      transTableList[0].border = '1'
      transTableList[0].appendChild(transTableList[1].getElementsByTagName('tbody')[0])
      transTableList[0].appendChild(transTableList[2].getElementsByTagName('tbody')[0])
      let theadThList = transTableList[0].getElementsByTagName('thead')[0].firstChild.getElementsByTagName('th')
      // console.log(theadThList)
      theadThList[theadThList.length - 1].parentNode.removeChild(theadThList[theadThList.length - 1])

      printWindow.print()
    },
    exportData() {
      this.$store.dispatch('projSettleInvoiceManage/downloadProjSettleInvoiceList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
        .then(res => {
          let blob = new Blob([res], {
            type: 'application/vnd.ms-excel'
          })
          let downloadUrl = window.URL.createObjectURL(blob)
          let anchor = document.createElement('a')
          anchor.href = downloadUrl
          anchor.download = this.$t('module.proj.project.pageName.settlePage') + '-' + (new Date().getTime()) + '.xlsx'
          anchor.click()
          window.URL.revokeObjectURL(downloadUrl)
        })
      // this.$refs.transTable.exportCsv({
      //   filename: this.$t('component.proj.paymentSumCard.cardTitle')
      // })
    },
    END_METHODS() {}
  },
  watch: {
    invValueAmt: 'calculateInvDeductibleAmt',
    invRate: 'calculateInvDeductibleAmt',
    indManualDeductibleValue: 'calculateInvDeductibleAmt',
    invType: 'calculateInvDeductibleAmt'
  },
  async mounted() {
    // debugger
    console.info('compId: ', this.compId)
    console.info('projId: ', this.projId)
    console.info('transId: ', this.transId)
    console.info('docMth: ', this.docMth)
    console.info('docIndex: ', this.docIndex)
    console.info('source: ', this.source)
    this.cleanForm()

    await this.$store.dispatch('systemAuthManage/findProjAuth', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('transIndexManage/findProjTransDocMonthIndexList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('confProjCtrAcctManage/findProjCtrAcctDDList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('rspCostColumnManage/findRspCostColumnDDList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('confProjSettleEntityManage/findProjSettleEntityList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('rspProjectManage/findProject', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.reloadDropdown()

    this.initFormValue()

    await this.goSearch()
  },
  async destroyed() {
    // debugger
    this.cleanForm()
  }
}
</script>

<style lang="less">
  /*@import '../../../theme/index.less';*/

  .edit-list-page .ivu-form-item {
    width: 100%;
  }
  .edit-list-page .search-wrapper .ivu-input-wrapper {
    width: 100% !important;
  }
  .edit-cls {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/proj/SettleInvoiceListCard.vue